module.exports = __webpack_public_path__ + "public/StoreIcon/store.svg?9fb2a576";